export default __webpack_public_path__ + "static/media/python.dd278af0.png";